import { useEffect, useState } from "react";
import { useCreateApiCall } from "./useCreateApiCall";
import { API } from "aws-amplify";
import { useAppDispatch } from "store/hooks";
import { showError } from "store/reducers/errorReducer";

export const useRecipient = ({ recipientId = null }) => {
  const dispatch = useAppDispatch();
  const [isRecipientLoading, setIsRecipientLoading] = useState(true);
  const [recipient, setRecipient] = useState(undefined);
  const [specialists, setSpecialists] = useState([]);

  const getSpecialistById = (specialistId) =>
    specialists?.find(({ id }) => id === specialistId);

  const { createApiCall } = useCreateApiCall();

  useEffect(() => {
    if (recipientId) {
      const loadData = createApiCall(async () => {
        setIsRecipientLoading(true);
        const result = await API.get(
          "restApi",
          `/recipients/${recipientId}`,
          {}
        );

        if (result?.error) {
          dispatch(showError(result.error));
          setIsRecipientLoading(false);
          return;
        }

        setRecipient(result?.Item);
        setSpecialists(result?.specialists);
        setIsRecipientLoading(false);
      });
      // load practice details from organizations
      loadData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [recipientId]);

  return {
    recipient,
    specialists,
    getSpecialistById,
    isRecipientLoading,
  };
};
